<template>
  <div
    v-bind:class="classObject"
    class="flex justify-center items-center border border-transparent text-base leading-6 font-medium rounded-md transition ease-in-out duration-150"
  >
    <div v-if="addCharacterImg" class="mr-4">
      <img class="h-16 md:h-20" src="/images/See-Octopus.png" />
    </div>
    <svg
      class="animate-spin -ml-1 mr-3 h-5 w-5"
      v-bind:class="loadingClassObject"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    {{ loadingText }}
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { PropType } from 'vue'

@Options({
  name: 'v-loader-animation',
  props: {
    px: {
      type: String as PropType<string>,
      default: 'px-4',
    },
    py: {
      type: String as PropType<string>,
      default: 'py-2',
    },
    text: {
      type: String as PropType<string>,
      default: 'text-gray-600',
    },
    loadingTextStyle: {
      type: String as PropType<string>,
      default: 'text-black',
    },
    loadingText: {
      type: String as PropType<string>,
      default: 'Loading',
    },
    addCharacterImg: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
  },

  computed: {
    classObject() {
      let classObject: any = {}

      if (this.px) {
        classObject[this.px] = true
      }

      if (this.py) {
        classObject[this.py] = true
      }

      if (this.text) {
        classObject[this.text] = true
      }

      return classObject
    },
    loadingClassObject() {
      let classObject: any = {}

      if (this.loadingTextStyle) {
        classObject[this.loadingTextStyle] = true
      }

      return classObject
    },
  },
})
export default class App extends Vue {}
</script>

<style scoped></style>
